import axios from 'axios'
import moment from 'moment'
import {FC, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import swal from 'sweetalert'
import {KTSVG} from '../../../_metronic/helpers'
import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {resetFilter, sipSelector, setFilter} from '../../../redux/slices/sipSlices'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'
import { hasFilterProps } from './helpers'

interface ButtonGroupsProps {
  role?: 'admin' | 'null' | 'salesAnper' | 'salesAdmin' | 'otorisator' | 'finance'
  hasCreate?: boolean
  hasExport?: boolean
  wrapperStyle?: React.CSSProperties
  hideSelectPageSize?: boolean
  hideReloadButton?: boolean
  onReloadTable: () => void
}

/**
 * Component ini menampilkan beberapa tombol yang berhubungan dengan SIP
 * seperti tombol tambah SIP, tombol export SIP, tombol reload table SIP
 */
export const ButtonGroups: FC<ButtonGroupsProps> = (props) => {
  const {t} = useTranslation()
  const {filter} = useAppSelector(sipSelector)
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useAppDispatch()

  /**
   * Handler untuk export data ke excel sesuai dengan filter yang diberikan
   */
  const handleExport = async () => {
    setIsLoading(true)

    const params = {
      SIP_number: filter?.SIP_number || undefined,
      created_at: filter?.created_at || undefined,
      customer_name: filter?.customer_name || undefined,
      customer_name_orderby: filter?.customer_name_orderby || undefined,
      estimate_date: filter?.estimate_date || undefined,
      flag: filter?.flag || undefined,
      from_date: filter?.from_date || undefined,
      outstanding_data: filter?.outstanding_data || undefined,
      perihal: filter?.perihal || undefined,
      po_number: filter?.po_number || undefined,
      po_number_orderby: filter?.po_number_orderby || undefined,
      price: filter?.price || undefined,
      product_type: filter?.product_type || undefined,
      sales_org_code: filter?.sales_org_code || undefined,
      sales_org_name: filter?.sales_org_name || undefined,
      sector_id: filter?.sector_id || undefined,
      status: filter?.status || undefined,
      to_date: filter?.to_date || undefined,
      total_quantum: filter?.total_quantum || undefined,
      total_request_price: filter?.total_request_price || undefined,
      total_request_quantum: filter?.total_request_quantum || undefined,
      credentials: localStorage.getItem('credential'),
    }

    try {
      const res = await axios({
        url: `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sip_order/export`,
        method: 'GET',
        params,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })

      const href = URL.createObjectURL(res.data)
      const dateNow = moment(new Date()).format('DD-MM-YYYY')
      const link = document.createElement('a')

      link.href = href
      link.setAttribute('download', `PI_SIP_Order_${dateNow}.xlsx`)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
    } catch {
      swal({title: t('Export Failed'), icon: 'error'})
    } finally {
      setIsLoading(false)
    }
  }

  const handleReloadTable = () => {
    props.onReloadTable()
    dispatch(resetFilter())
  }

  const handlePageSizeChange = (value: number | undefined | null) => {
    dispatch(setFilter({...filter, per_page: value ?? 5}))
  }

  const handleResetFilter = () => {
    dispatch(resetFilter())
  }

  const hasFilter = () => {
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-sip-filter') as string)
      if(hasFilterProps(persisted)){
        return persisted
      }

      return null
    }catch(e){ return null }
  }

  return (
    <StyledButtonGroups
      leftContent={
        <>
        {
          !props.hideSelectPageSize ? (
            <SelectPageSize
              initialValue={filter?.per_page ?? 5}
              onChange={(value: any) => handlePageSizeChange(value?.value)}
            />
          ) : null
        }
        { hasFilter() && <button type="button" onClick={() => handleResetFilter()} className="btn btn-outline-danger btn-sm">Clear Filter</button> }
        </>
      }
      rightContent={
        <>
          {' '}
          {props.hasCreate && (
            <div
              className='card-toolbar me-2'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('kontrak-tambah') + ' SIP'}
            >
              <Link
                to='/management/si/create'
                className='btn btn-primary d-flex align-items-center h-100'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                <p>{t('order-tambah')} SIP</p>
              </Link>
            </div>
          )}
          {props.hasExport && (
            <button
              className='btn btn-primary me-2'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('unduh')}
              onClick={handleExport}
              disabled={isLoading}
            >
              {isLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Unduh')}
            </button>
          )}
          {/* {!props.hideReloadButton && (
            <button
              className='btn btn-primary'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('reload table')}
              onClick={handleReloadTable}
            >
              <i className='fas fa-sync-alt'></i>
            </button>
          )} */}
        </>
      }
    />
  )
}

ButtonGroups.defaultProps = {
  role: 'null',
  hideSelectPageSize: false,
  hideReloadButton: false,
}
